import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/common/ui/select";

export interface EnumControlProps {
  readonly capabilityId: string;
  readonly values: readonly string[];
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly disabled?: boolean;
}

export function EnumControl({
  capabilityId,
  values,
  value,
  onChange,
  disabled = false,
}: EnumControlProps): JSX.Element {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        id={`${capabilityId}-enum`}
        data-testid="entitlement-control-enum"
        className="w-full"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {values.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
